import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/pages/home/index.vue'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'hash',
  base: './',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    }
  ]
})
